<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Teacher Training Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" return-object label="Academic Year" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" multiple dense rounded required v-model="inst"
                            :items="inst_list" item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="activity_type"
                            :items="activity_type_list" item-text="activitytype" item-value="activity_type_id"
                            label="Organization" outlined />
                    </v-col>


                </v-row>

                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="org_id == 'sbpps'">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="department"
                            :items="department_list" item-text="department_name" item-value="department_id"
                            label="Department" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="section" :items="section_list"
                            item-text="section_name" item-value="section_id" label="Section" outlined />
                    </v-col>
                    <!-- <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-btn class="button" v-if="ay && section != '' && inst.length > 0 && department != ''"
                            @click="getReport()" :loading="loader">Fetch Report</v-btn>
                    </v-col> -->
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-btn class="button"
                            v-if="ay && section != '' && inst.length > 0 && (org_id !== 'sbpps' || (org_id === 'sbpps' && department != ''))"
                            @click="getReport()" :loading="loader">
                            Fetch Report
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        <v-card flat class="box" v-if="inst_training_data != ''">
            <!-- shiv code -->
            <v-row dense class="no-display" justify="center">
                <v-col cols="12" sm="3" md="3">
                    <v-btn rounded color="success" outlined
                        @click="fnExcelReport('my-table-id', 'TeacherTrainingReport')" :loading="loader"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon
                            left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="ma-2 no-display" tile outlined color="warning" @click="showLogo()">
                        Hide /Show Logo
                    </v-btn>
                </v-col>
            </v-row>

            <div id="my-table-id">
                <v-simple-table></v-simple-table>
                <div v-if="org_basic_data">
                    <v-row dense justify="center">
                        <v-col v-if="org_basic_data.trust_logo && show_logo" cols="12" sm="2" md="2" align="right">
                            <img :src="org_basic_data.trust_logo" width="50%" alt="logo" />
                        </v-col>
                        <v-col cols="12" sm="8" md="8">
                            <center>
                                <br />
                                <strong>
                                    <h3>
                                        <span v-if="org_basic_data.trust_name"> {{ org_basic_data.trust_name }}</span>
                                    </h3>
                                </strong>
                                <strong>
                                    <h1 v-if="org_basic_data.school_name">
                                        <!-- <span v-if="org_basic_data.school_name"> -->
                                        {{ org_basic_data.school_name }}
                                        <!-- </span> -->
                                    </h1>
                                </strong>
                                <br />
                                <strong>
                                    <h3 v-if="org_basic_data.cbsc_no">
                                        Affiliation Number - {{ org_basic_data.cbsc_no }}
                                    </h3>
                                </strong>
                                <br />
                                <strong>
                                    <h3>
                                        Details of the Training Programmes attended by School Faculty for {{ ay.ay }}
                                    </h3>
                                </strong>

                                <br />
                                <strong v-if="training_dates">
                                    <h3>
                                        {{ training_dates }}
                                    </h3>
                                </strong>
                            </center>
                        </v-col>
                        <v-col :src="org_basic_data.school_logo" v-if="show_logo && org_basic_data.school_logo"
                            cols="12" sm="2" md="2" align="left">
                            <br />
                            <img :src="org_basic_data.school_logo" width="40%" alt="logo" />
                        </v-col>
                    </v-row>
                </div>
                <v-simple-table v-if="inst_training_data != ''" dense class="elevation-1 mytable" fixed-header>
                    <thead>
                        <tr>
                            <th>Name of the teacher</th>
                            <th>Designation</th>
                            <th v-if="org_id == 'sbpps'">Department</th>
                            <th>Section</th>
                            <th>Total No. Of Hours</th>
                            <th>Attended / Conducted</th>
                            <th>Online / Offline</th>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th>Title of training programme undergone</th>
                            <th>Organized By</th>
                            <th>Number of hours of training programme</th>
                            <th>Number of Minutes of training programme</th>
                        </tr>
                    </thead>
                    <tbody v-for="(it, index) in inst_training_data" :key="index">
                        <td :rowspan="it.training_data.length + 1">{{ it.name }}</td>
                        <td :rowspan="it.training_data.length + 1">
                            {{ it.inst_designation }}
                        </td>
                        <td :rowspan="it.training_data.length + 1" v-if="org_id == 'sbpps'">
                            {{ it.department }}
                        </td>
                        <td :rowspan="it.training_data.length + 1">
                            {{ it.section }}
                        </td>
                        <td :rowspan="it.training_data.length + 1">
                            {{ it.totalHoursAndMinutes }}
                        </td>
                        <!-- <td > -->
                        <tr v-for="(t, index) in it.training_data" :key="index">
                            <td>{{ t.conducted_attended }}</td>
                            <td>{{ t.online_offline }}</td>
                            <td>{{ t.date2 }}</td>
                            <td>{{ t.date2_end }}</td>
                            <td>{{ t.description }}</td>
                            <td>{{ t.activitytype }}</td>
                            <td>{{ t.no_of_hr }}</td>
                            <td>{{ t.no_of_minutes }}</td>
                        </tr>
                        <!-- </td> -->
                    </tbody>
                </v-simple-table>
            </div>
        </v-card>
    </div>
    <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        training_dates: "",
        // extraBreadcrumbItems: [
            
        // ],
        // breadcrumbClass: "breadcrumb-style1",
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        title: "",
        inst_list: [],
        inst: [],
        ay_list: [],
        ay: null,
        org_basic_data: [],
        inst_training_data: [],
        show_logo: true,
        activity_type_list: [],
        section_list: [],
        department_list: [],
        activity_type: null,
        section: null,
        department: null,
        org_id: null,
    }),
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            // var blob = new Blob([tab_text], {
            //     type: "application/vnd.ms-excel;charset=utf-8",
            // });
            // window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        showLogo() {
            if (this.show_logo) {
                this.show_logo = false;
            } else {
                this.show_logo = true;
            }
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        getReport() {
            this.loader = true;

            const data = {
                ay: this.ay.id,
                inst: this.inst,
                activity_type: this.activity_type,
                department: this.department,
                section: this.section
            };
            axios
                .post("/Admission/getTrainingData", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.inst_training_data = res.data.inst_training_data;
                        this.org_basic_data = res.data.org_basic_data;
                        this.training_dates = res.data.training_dates;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.loader = false;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.loader = false;
                })
                .finally(() => { });
        },
        onLoad() {
            axios
                .post("/Examination/getResultAnalysisData")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.inst_list = res.data.inst_list;
                        this.ay_list = res.data.ay_list;
                        this.activity_type_list = res.data.activity_type_list
                        this.section_list = res.data.section_list
                        this.department_list = res.data.department_list
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => { });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
        this.org_id = localStorage.getItem("EPS-tenant");
    },
    watch: {},
};
</script>
<style scoped>
tr,
td,
th {
    border: 1px solid #ccc;
    width: auto;
    font-size: small;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    /* img {
    width: 100% !important;
  } */

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .box {
        background-color: white !important;
        /* margin: 8px !important;
    padding: 8px; */
        border: none !important;
        /* overflow: hidden !important; */
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        /* size: 18in 17in; */
        size: 20in 17in;
    }
}
</style>
